import React from 'react';
import { ClockIcon, FilesIcon, ScissorsIcon, GraduationCapIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, FilesIcon, ScissorsIcon, GraduationCapIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-134" data-mp="3m1fj9yalw80t">
      <div className="mx-auto max-w-5xl" data-id="element-135" data-mp="nhys654seo8p">
        <SectionHeading id="pain-heading" title={<>
              Vous aimez enseigner la coiffure… <Accent data-id="element-137" data-mp="dt71s1fdkbzw">mais préparer vos cours vous prend trop de temps ?</Accent>
            </>} data-id="element-136" data-mp="nl32lk8uig7t" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-138" data-mp="8unjqc3wjkct">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6" data-id="element-139" data-mp="11irqz224g5hm" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-white" data-id="element-140" data-mp="3bdhppllepqxk">
                  <Icon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-141" data-mp="3gcuc658d8vzm" />
                </span>
                <span data-id="element-142" data-mp="31mercrjv3q1z">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-143" data-mp="31n69p0og7rab">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-144" data-mp="2slov5mqovxnq">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-145" data-mp="2iplw4pr4wf50">
          Votre temps est précieux. <Accent data-id="element-146" data-mp="gxgx6ub7whks">Vous devriez pouvoir le consacrer à vos élèves</Accent>, pas uniquement à
          préparer vos documents.
        </p>
      </div>
    </section>;
}